import {useMemo, useState} from "react";
import {Stack, Typography} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {appStyles} from "../../../../AppStyles.ts";
import {StyledInputBase, StyledSearch, StyledSearchIconWrapper} from "../../../AppStyledComponents.tsx";
import type {Transaction} from "../../../../sdo/Transaction.ts";
import TransactionCard from "../../intel/panels/transactions/TransactionCard.tsx";

// TODO: Replace with API call to load transactions from AResourceProfileManager.readTransactions()
function buildTestData(): Transaction[] {
    return [
        {
            uid: "1",
            typeKey: "IMPORT",
            extensionKey: "CSV_IMPORTER",
            display: "Threat Indicators Import - Batch 2025-041",
        },
        {
            uid: "2",
            typeKey: "ENRICHMENT",
            extensionKey: "GEO_LOOKUP",
            display: "Geolocation Enrichment - IP Range 10.0.0.0/8",
        },
        {
            uid: "3",
            typeKey: "PUBLISH",
            extensionKey: "STIX_EXPORT",
            display: "STIX Bundle Export - Campaign Alpha",
        },
        {
            uid: "4",
            typeKey: "RESOLVE",
            extensionKey: "NAME_MATCHER",
            display: "Name resolution pass against partner watchlist",
        },
    ];
}

function UXResourceTransactionsPanel() {
    const [transactions] = useState<Transaction[]>(buildTestData);
    const [filterText, setFilterText] = useState("");

    const filtered = useMemo(() => {
        if (!filterText.trim()) return transactions;
        const q = filterText.toLowerCase();
        return transactions.filter((t) => JSON.stringify(t).toLowerCase().includes(q));
    }, [transactions, filterText]);

    const handleNavigate = (transaction: Transaction) => {
        // TODO: Navigate to transaction details view
        console.log("NAVIGATE::TRANSACTION::" + transaction.uid);
    };

    return (
        <Stack sx={appStyles.defaultPanelContainer} direction="column" padding={1} width="100%">
            {/* Title */}
            <Stack direction="row" padding={1} justifyContent="center">
                <Typography sx={appStyles.panelSectionTitle}>Transactions</Typography>
            </Stack>

            {/* Filter bar */}
            <Stack direction="row" spacing={1} padding={1} alignItems="center" justifyContent="center" sx={{position: "relative"}}>
                <StyledSearch>
                    <StyledSearchIconWrapper>
                        <SearchIcon sx={{fontSize: 16, color: "#7093a0"}}/>
                    </StyledSearchIconWrapper>
                    <StyledInputBase
                        placeholder="Filter transactions..."
                        value={filterText}
                        onChange={(e) => setFilterText(e.target.value)}
                    />
                </StyledSearch>

                <Typography sx={appStyles.panelFilterCount}>
                    Showing {filtered.length} of {transactions.length}
                </Typography>
            </Stack>

            {/* Transaction cards list */}
            <Stack direction="column" spacing={1} sx={{...appStyles.defaultPanelCardsWrapper, padding: "8px", alignItems: "stretch"}}>
                {filtered.map((transaction) => (
                    <TransactionCard
                        key={transaction.uid}
                        transaction={transaction}
                        onNavigate={handleNavigate}
                    />
                ))}
                {filtered.length === 0 && (
                    <Typography sx={{
                        color: "rgba(242, 245, 250, 0.4)",
                        fontSize: "0.80rem",
                        textAlign: "center",
                        padding: "24px",
                    }}>
                        No transactions match the current filter.
                    </Typography>
                )}
            </Stack>
        </Stack>
    );
}

export default UXResourceTransactionsPanel;
